import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// components
import CaretDownIcon from '@icons/CaretDownIcon';
import { BodyMedium, BodySmall, ButtonNoStyles, ButtonPrimaryLarge } from '@styled';

// functionality
import { formatMoney } from '@general/helpers/currency.helpers';
import colors from '@general/colors';
import cartPropTypes from '@react/propTypes/cartPropTypes';
import CaretUpIcon from '@icons/CaretUpIcon';

const ComponentContainerStyled = styled.div`
    align-items: center;
    background-color: ${colors.white};
    box-shadow: 0px -8px 12px -8px rgba(87, 87, 87, 0.2);
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;
`;

const CartSummaryMobileBar = ({ cart, isDrawerOpen, navLabel, onExpandToggleClick, onNavClick }) => {
    return (
        <ComponentContainerStyled>
            <div>
                <BodyMedium>Total: {formatMoney(cart.total, cart.locale)}</BodyMedium>

                <ButtonNoStyles className="flex items-center mt-0.25rem" onClick={() => onExpandToggleClick(true)}>
                    <BodySmall className="mr-0.5rem text-link">Order Summary</BodySmall>
                    {!isDrawerOpen && <CaretDownIcon color={colors.link} />}
                    {isDrawerOpen && <CaretUpIcon color={colors.link} />}
                </ButtonNoStyles>
            </div>

            <div>
                <ButtonPrimaryLarge onClick={() => onNavClick()}>{navLabel}</ButtonPrimaryLarge>
            </div>
        </ComponentContainerStyled>
    );
};

CartSummaryMobileBar.propTypes = {
    cart: cartPropTypes,
    isDrawerOpen: PropTypes.bool.isRequired,
    navLabel: PropTypes.string.isRequired,
    onExpandToggleClick: PropTypes.func.isRequired,
    onNavClick: PropTypes.func.isRequired,
};

export default CartSummaryMobileBar;
